import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { toast } from "sonner";

export default function LeadForm({ initial, onContinue }) {
  const [form, setForm] = useState(
    initial || { name: "", phone: "", email: "" }
  );

  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.phone.trim() || !form.email.trim()) {
      toast.error("Compila tutti i campi per continuare.");
      return;
    }
    if (!/^\S+@\S+\.\S+$/.test(form.email)) {
      toast.error("Inserisci un indirizzo email valido.");
      return;
    }
    onContinue(form);
  };

  const fields = [
    { k: "name", label: "Nome e cognome", type: "text", placeholder: "Mario Rossi" },
    { k: "phone", label: "Cellulare", type: "tel", placeholder: "+39 333 1234567" },
    { k: "email", label: "Email", type: "email", placeholder: "mario@azienda.it" },
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -30 }}
      transition={{ duration: 0.5 }}
      className="w-full max-w-xl mx-auto"
      data-testid="lead-form-view"
    >
      <span className="text-xs font-bold tracking-[0.25em] uppercase text-[#8b5cf6]">
        Domanda 01 / 03
      </span>
      <h2 className="mt-5 font-display font-bold tracking-tight text-3xl sm:text-4xl text-white leading-tight">
        Iniziamo: i tuoi dati
      </h2>
      <p className="mt-3 text-zinc-400">
        Lasciaci i tuoi contatti per ricevere la soluzione su misura e la
        consulenza gratuita.
      </p>

      <form onSubmit={handleSubmit} className="mt-8 space-y-5" data-testid="lead-form">
        {fields.map((fld) => (
          <div key={fld.k}>
            <label className="block text-xs font-bold tracking-[0.15em] uppercase text-zinc-500 mb-2">
              {fld.label}
            </label>
            <input
              type={fld.type}
              value={form[fld.k]}
              onChange={update(fld.k)}
              placeholder={fld.placeholder}
              data-testid={`lead-input-${fld.k}`}
              className="mc-input w-full rounded-xl border border-white/10 bg-zinc-900/80 px-5 py-4 text-white placeholder:text-zinc-600 transition-[border-color,box-shadow]"
            />
          </div>
        ))}

        <motion.button
          type="submit"
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.97 }}
          data-testid="lead-continue-btn"
          className="group w-full inline-flex items-center justify-center gap-3 rounded-full bg-[#6d28d9] hover:bg-[#8b5cf6] px-8 py-4 text-base font-semibold text-white transition-colors"
        >
          Continua
          <span className="flex h-7 w-7 items-center justify-center rounded-full bg-white/15 group-hover:rotate-45 transition-transform">
            <ArrowUpRight className="h-4 w-4" />
          </span>
        </motion.button>
        <p className="text-center text-xs text-zinc-600">
          I tuoi dati sono al sicuro e non verranno condivisi con terze parti.
        </p>
      </form>
    </motion.div>
  );
}
